/**
 * Displays a dark overlay with a input field
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import OverlayImage from '../media/OverlayImage';
import Form from '../form/Form';
import Input from '../form/formComponents/Input';
import SubmitButton from '../form/formComponents/SubmitButton';
import './media-thumbnail.css';

class EditOverlay extends Component {
    static propTypes = {
        clickable: PropTypes.bool.isRequired,
        editMode: PropTypes.bool.isRequired,
        defaultValue: PropTypes.string,
        label: PropTypes.string.isRequired,
        imgSrc: PropTypes.string.isRequired,
        placeholder: PropTypes.string.isRequired,
        onCancel: PropTypes.func.isRequired,
        onClick: PropTypes.func.isRequired,
        playIcon: PropTypes.element,
        onSubmit: PropTypes.func,
    };

    onSubmit(model) {
        this.props.onSubmit(model.editDescription);
    }

    renderEditContent() {
        if (this.props.editMode) {
            return (
                <div className="media-overlay profiletxt trans-background-white">
                    <div className="u-position-relative">
                        <Form onValidSubmit={this.onSubmit.bind(this)}>
                            <div className="input input--text">
                                <label htmlFor={this.props.imgSrc}>
                                    {this.props.label}
                                </label>
                                <Input
                                    autoFocus
                                    id={this.props.imgSrc}
                                    name="editDescription"
                                    placeholder={this.props.placeholder}
                                    type="text"
                                    validationErrorMsg="Feltet kan max inneholde 255 tegn"
                                    validations="maxLength:255"
                                    value={this.props.defaultValue}
                                />
                            </div>
                            <div className="u-mt16">
                                <SubmitButton
                                    className="button--cta"
                                    value="Lagre"
                                />
                                <button
                                    className="button u-ml16"
                                    onClick={this.props.onCancel}
                                    type="button"
                                >
                                    Avbryt
                                </button>
                            </div>
                        </Form>
                    </div>
                </div>
            );
        }
    }

    render() {
        const editClasses = cn({
            editmode: this.props.editMode,
            hoverable: !this.props.editMode,
            clickable: this.props.clickable,
        });

        return (
            <div className={editClasses} onClick={this.props.onClick}>
                <OverlayImage
                    defaultValue={this.props.defaultValue}
                    imgSrc={this.props.imgSrc}
                >
                    {this.props.playIcon}
                    {this.renderEditContent()}
                </OverlayImage>
            </div>
        );
    }
}

export default EditOverlay;
